import React, { useState } from 'react';
import { inventoryAPI } from '../../services/api';
import { toast } from 'react-toastify';

// End-of-Shift Scrap close-out (Phase 4). Mandatory before the shift can be
// ended from the primary End-Shift button: records the shift's start-up lumps
// and edge trim, then runs the supplied onComplete() (the actual end-shift).
const ScrapModal = ({ onClose, onComplete }) => {
    const [lumps, setLumps] = useState('');
    const [trim, setTrim] = useState('');
    const [busy, setBusy] = useState(false);

    const valid = (v) => v !== '' && Number.isFinite(Number(v)) && Number(v) >= 0;
    const canSubmit = valid(lumps) && valid(trim);

    const submit = async (e) => {
        e.preventDefault();
        if (!canSubmit) { toast.error('Enter both scrap figures in KG (0 is allowed, blank is not)'); return; }
        setBusy(true);
        try {
            await inventoryAPI.recordScrap({ startupLumpsKg: Number(lumps), edgeTrimKg: Number(trim) });
            // Scrap saved — now actually end the shift.
            await onComplete();
            onClose();
        } catch (err) {
            toast.error(err.response?.data?.error || 'Failed to record scrap');
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden">
                <div className="p-6 border-b border-gray-100">
                    <h3 className="text-xl font-bold text-text-primary">End-of-Shift Scrap</h3>
                    <p className="text-sm text-text-secondary mt-1">Record this shift's scrap before closing. Enter 0 if there was none — the fields cannot be left blank.</p>
                </div>
                <form onSubmit={submit} className="p-6 flex flex-col gap-4">
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-bold text-text-secondary">Start-up Lumps (KG)</label>
                        <input
                            type="number" min="0" step="0.01" inputMode="decimal" autoFocus
                            className="w-full px-4 py-3 bg-background border border-gray-200 rounded-lg text-text-primary font-bold focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all"
                            placeholder="0.00" value={lumps} onChange={(e) => setLumps(e.target.value)}
                        />
                    </div>
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-bold text-text-secondary">Edge Trim (KG)</label>
                        <input
                            type="number" min="0" step="0.01" inputMode="decimal"
                            className="w-full px-4 py-3 bg-background border border-gray-200 rounded-lg text-text-primary font-bold focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all"
                            placeholder="0.00" value={trim} onChange={(e) => setTrim(e.target.value)}
                        />
                    </div>
                    <div className="flex justify-end gap-3 pt-2">
                        <button type="button" onClick={onClose} disabled={busy} className="px-5 py-2.5 rounded-lg font-bold text-text-secondary hover:bg-gray-200 transition-colors disabled:opacity-50">Cancel</button>
                        <button type="submit" disabled={!canSubmit || busy} className="px-5 py-2.5 rounded-lg font-bold bg-primary text-white hover:bg-primary-dark shadow-soft hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed">
                            {busy ? 'Closing shift…' : 'Save Scrap & End Shift'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ScrapModal;
